module.exports = __webpack_public_path__ + "img/img10.fb665228.png";